module.exports = __webpack_public_path__ + "img/93.53e356f4.jpg";